import { useState } from "react";
import { MoveUp, MoveDown } from "lucide-react";
import { headerConfig } from "./header-config";
import useProductSupplierResponsesGridTemplate from "../utils/useProductSupplierResponsesGridTemplate";

export default function TableRowProductSupplierResponsesHeader() {
  const [sort, setSort] = useState<{
    column: string;
    direction: "ASC" | "DESC" | null;
  }>({
    column: "",
    direction: "ASC",
  });

  const handleSort = (field: string) => {
    if (sort.column === field) {
      // Aynı column'a tıklandı: ASC → DESC → null → ASC
      if (sort.direction === "ASC") {
        setSort({ column: field, direction: "DESC" });
      } else if (sort.direction === "DESC") {
        setSort({ column: "", direction: null });
      } else {
        setSort({ column: field, direction: "ASC" });
      }
    } else {
      // Farklı column'a tıklandı: yeni column ASC olur
      setSort({ column: field, direction: "ASC" });
    }
  };

  const getInnerClassName = (field: string, sortable: boolean) => {
    const isActive = sort.column === field && sort.direction !== null;
    const baseClasses =
      "flex select-none items-center ml-[-8px] py-[8px] px-[8px] overflow-clip rounded-md shrink-0";

    const bgClasses = isActive ? "bg-accent" : "bg-white";
    const cursorClass = sortable ? "cursor-pointer hover:bg-accent" : "";

    return `${baseClasses} ${bgClasses} ${cursorClass}`;
  };

  return (
    <div
      className="grid w-full h-[40px] border-b border-border bg-white"
      style={{
        gridTemplateColumns: useProductSupplierResponsesGridTemplate(),
      }}
    >
      {headerConfig.map((config) => {
        const isActive =
          sort.column === config.field && sort.direction !== null;
        const showArrow = isActive && config.sortable;

        return (
          <div key={config.field} className={config.parentClassName}>
            <div
              className={getInnerClassName(config.field, config.sortable)}
              onClick={() => config.sortable && handleSort(config.field)}
            >
              <div className="text-[12px] font-600 text-muted-foreground flex items-center gap-1">
                {config.label}
                {showArrow && (
                  <>
                    {sort.direction === "ASC" ? (
                      <MoveUp className="w-3 h-3" />
                    ) : (
                      <MoveDown className="w-3 h-3" />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        );
      })}
      <div className="flex items-center h-12 justify-center p-1 relative shrink-0 w-[62px]"></div>
    </div>
  );
}
